module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crosaudio"
  }, [_c('audio', {
    ref: "crosaudio"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a759cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CrosAudio.vue
// module id = 99
// module chunks = 0